import { API_BASE_URL } from '../config';
import {
  buildProfessionalDualModeKey,
  clearAllProfessionalDualModeChoices,
} from './professionalDualModeStorage';

export async function resolvePostLoginRoute() {
  const authToken = localStorage.getItem('authToken');
  const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};

  const statusRes = await fetch(`${API_BASE_URL}/api/profile/status`, {
    credentials: 'include',
    headers,
  });

  if (!statusRes.ok) {
    return '/dashboard';
  }

  const status = await statusRes.json();
  const isAdminUser = Boolean(status?.user?.isAdmin);
  if (isAdminUser) {
    // Normal uygulama login akışında admin kullanıcıları da dashboard'a iner.
    // Admin paneline geçiş /admin/login veya profil menüsü üzerinden yapılır.
    return '/dashboard';
  }

  if (status.isAssistantChef) {
    return '/partner-dashboard';
  }

  if (!status.completedRegistration) {
    return '/registration-survey';
  }

  if (status.shouldResumeOnboarding) {
    return '/onboarding-setup';
  }

  try {
    const proRes = await fetch(`${API_BASE_URL}/api/professional/profile`, {
      credentials: 'include',
      headers,
    });
    if (proRes.ok) {
      const pro = await proRes.json();
      if (pro?.exists && pro?.profile?.professionalType === 'dietitian') {
        const userId = pro?.profile?.userId;
        const key = buildProfessionalDualModeKey(userId);
        const choice = key ? localStorage.getItem(key) : null;
        if (!choice) return '/professional-login-choice';
        return choice === 'yes' ? '/dashboard' : '/diyetisyen-panel';
      }
      if (pro?.exists && pro?.profile?.professionalType === 'pt') {
        const userId = pro?.profile?.userId;
        const key = buildProfessionalDualModeKey(userId);
        const choice = key ? localStorage.getItem(key) : null;
        if (!choice) return '/professional-login-choice';
        return choice === 'yes' ? '/dashboard' : '/pt-panel';
      }
      clearAllProfessionalDualModeChoices();
    }
  } catch (_) {
    // ignore professional route detection errors
  }

  return '/dashboard';
}
